import React from 'react';

import lang from '../../../../../lib/language';
import { getLocalDowntime } from '../../../../../lib/util/DateTimeHelpers';
import { useSuccessionTimer } from '../../../../../lib/util/hooks/SuccessionTimerHook';

import styles from './FXStatusTime.module.scss';

const FXStatusTime = () => {
  const { timerValueAsString, isEnabled } = useSuccessionTimer();
  if (!isEnabled) return null;

  const { localDowntimeStart, localDowntimeEnd } = getLocalDowntime();

  return (
    <div className={styles.wrapperMarketInfo}>
      <h6 className={styles.title}>{lang.fxHammerMaintenance()}</h6>
      <div className={styles.description}>
        <div>
          {lang.fxHammerExchangeDowntime()}
          {' '}
          {`${localDowntimeStart}-${localDowntimeEnd}`}
        </div>
        <div>
          {lang.fxHammerExchangeAvalaiableIn()}
          {' '}
          {timerValueAsString && <span className={styles.marketTimer}>{timerValueAsString}</span>}
        </div>
      </div>
    </div>
  );
};

export default FXStatusTime;
